import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	DNAHeadingH1,
	AlertFatalError,
	AlertRecoverableError,
} from '../';

export default class PageBoilerplateDefault extends Component {
	static propTypes = {
		useBoilerplateHeadingH1: PropTypes.bool.isRequired,
		useBoilerplateAlertRecoverableError: PropTypes.bool,
		HeadingH1Content: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object,
		]),
		HeadingH1DecoratorClass: PropTypes.string,
		globalAlertsDecoratorClass: PropTypes.string,
		intl: PropTypes.object.isRequired,
		mainClassName: PropTypes.string,
		isRecoverableError: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.string,
			PropTypes.object,
		]),
		children: PropTypes.any.isRequired,
		handleSubmit: PropTypes.func,
	};
	static defaultProps = {
		useBoilerplateHeadingH1: true,
		useBoilerplateAlertRecoverableError: true,
	};
	handleSubmit(e) {
		const { handleSubmit } = this.props;
		e && e.preventDefault && e.preventDefault();
		handleSubmit && handleSubmit(e);
	}
	render() {
		const {
			intl,
			useBoilerplateHeadingH1,
			HeadingH1Content,
			HeadingH1DecoratorClass,
			isRecoverableError,
			children,
			mainClassName,
			globalAlertsDecoratorClass,
			useBoilerplateAlertRecoverableError,
		} = this.props;

		return (
			<section>
				{ useBoilerplateAlertRecoverableError &&
					<AlertRecoverableError
						{...this.props}
						decoratorClass={globalAlertsDecoratorClass}
						intl={intl}
						isRecoverableError={isRecoverableError} />
				}
				<main role='main' className={`login-main-default ${mainClassName ? mainClassName : ''}`}>
					<form noValidate onSubmit={::this.handleSubmit}>

						{ useBoilerplateHeadingH1 &&
							<DNAHeadingH1
								headingDecoratorClass={HeadingH1DecoratorClass}>
								{ HeadingH1Content }
							</DNAHeadingH1>
						}

						{ children }
					</form>
				</main>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/components/page/PageBoilerplateDefault.js